var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 44,
    viewBox: "0 0 52 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9862 36.9589C31.6942 39.3757 28.3976 41.1388 25.8059 42C17.6489 39.2895 2.5 27.6365 2.5 14.8183C2.5 7.73909 8.23909 2 15.3183 2C19.6532 2 23.487 4.15231 25.8059 7.4466C26.9879 5.76299 28.5582 4.38897 30.3838 3.44088C32.2094 2.49279 34.2365 1.99855 36.2936 2C43.3728 2 49.1119 7.73909 49.1119 14.8183C49.1119 16.854 48.7297 18.8595 48.055 20.8044",
    stroke: "#E55639",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3018 27.6365H33.9629L37.4588 22.9753L40.9547 32.2977L44.4063 27.6365H49.1118",
    stroke: "#E55639",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeart);
export default __webpack_public_path__ + "static/media/icon-heart.105eb77c66dc02993ffbd0b5a11c5b7e.svg";
export { ForwardRef as ReactComponent };